import Api from "./Api";

const endpoint = "/probentyp";
export default {
    get() {
        var usedParams = {};
        return Api.fetchData(endpoint);
    },
    getKlassen() {
        return Api.fetchData(endpoint + "/klassen");
    },
    getBenefit(id) {
        return Api.fetchData(endpoint + "/benefit/" + id);
    },
    post(data) {
        return Api.postData(endpoint, data);
    },
    put(id, data) {
        return Api.putData(endpoint + "/" + id, data);
    },
    putSorting(data) {
        return Api.putData(endpoint + "/sorting", data);
    },
    putBenefit(id, data) {
        return Api.putData(endpoint + "/benefit/" + id, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + "/" + id);
    }
};
